import { all } from 'redux-saga/effects';
import payment from './payment';

export const paymentSaga = function* root() {
  yield all([payment()]);
};
